import React, { Component } from 'react';
import { Field } from 'redux-form';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';

import { getText } from 'misc/helpers';

class FileUpload extends Component {
    
    onDrop(field, filesToUpload) {
        field.input.onChange(filesToUpload);
        // Add stuff you want to happen on drop 
    }
    
    render = () => {
        const renderDropzoneInput = (field) => {
            const files = field.input.value;
            
            
            return (
              <div className="file-drop-zone">
                
                <Dropzone
                  name={field.name}
                  onDrop={( filesToUpload, e ) => this.onDrop(field, filesToUpload)}
                  multiple={this.props.multiple ? this.props.multiple : true} 
                  accept={this.props.acceptedFiles}
                >
                    <div className="drop-zone-content">
                
                        <img className="attachment-ico" src="assets/images/inbox/ico_attachments.svg" alt="" />
               
                            <div className={files ? "info" : "info instructions"}>
                                {!files &&
                                    getText('Missing','Klicka eller dra och släpp din bild här')
                                }
                                {field.meta.touched && field.meta.error && (
                        
                                    <span className="error">{field.meta.error}</span>
                                )}
                                        
                                {files && Array.isArray(files) && (
                                    files.map((file, i) => <span key={i}>{file.name}</span>) 
                                )}
                            </div>
                    </div>
                   
                </Dropzone>
              </div>
            );
          }
        
        return <Field name={this.props.name} component={renderDropzoneInput} />;
    };
}

export default connect()(FileUpload);


// WEBPACK FOOTER //
// ./src/components/shared/form/FileUpload.js